import {useBuyerRealtimeUpdates} from '@/features/buyers/hooks';
import {useDocumentRealtimeUpdates} from '@/features/documents/hooks';
import {usePaymentRealtimeUpdates} from '@/features/payments/hooks';
import {
  useFatcaCrsRealtimeUpdates,
  useTrustAccountRealtimeUpdates
} from '@/features/trust-accounts/hooks';
import {useMembersRealtimeUpdates} from '@/features/trust-accounts/members';

export function useRealtimeUpdates(): void {
  useDocumentRealtimeUpdates();
  useTrustAccountRealtimeUpdates();
  usePaymentRealtimeUpdates();
  useFatcaCrsRealtimeUpdates();
  useBuyerRealtimeUpdates();
  useMembersRealtimeUpdates();
}
